<script>
    export let clickPlay = () => {};
    export let gotoAbout = () => {};
    export let current_language;
    export let current_game = '';

    let games = [];
    let config;
    export let cfg;

	async function getConfig() {
		const res = await fetch(`games.json`);
		const config_received = await res.json();

		if (res.ok) {
            config = config_received;
            setupUI()
			return config_received;
		} else {
			throw new Error("Error");
		}
	}

    function setupUI(){
        for (let g=0; g < config.length; g++) {
            if (config[g]["id"] == current_language) {
                cfg = config[g];

                games = cfg["games"];
            }
        }
    }
    let promisedConfig = getConfig();
</script>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>

<main>
	<h1>{cfg["title"]}</h1>
</main>


{#await promisedConfig}
	<p>...waiting for configuration to be loaded</p>
{:then config}
    <select id="language-selector" bind:value={current_language} on:change={setupUI}>
    {#each config as language}
        <option value="{language.id}">{language.name}</option>
    {/each}
    </select>
{:catch error}
	<p style="color: red">{error.message}</p>
{/await}

<h2>{cfg["text"]["games"]}</h2>
<div>
    <select id="game-selector" bind:value={current_game}>
       {#each games as game}
          <option value="{game.id}">{game.name}</option>
       {/each}
    </select>
</div>
<button on:click={clickPlay}>{cfg['text']['play']}</button>


<div>
    <hr>
    <button on:click={gotoAbout}>About</button>
</div>
